import { useState } from "react";
import {
  isInputEmpty,
  validateEmail,
  validateMobileNumber,
} from "../../../utility/validations";
import Button from "../../common/buttons/button/Button";
import DescriptionInput from "../../common/inputs/descriptionInput/descriptionInput";
import LabelInput from "../../common/inputs/labelInput/LabelInput";
import "./ContactUsForm.css";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import Toaster from "../../common/toaster";
import { ToastContainer } from "react-toastify";

const ContactUsForm = () => {
  //states
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [desc, setDesc] = useState("");

  // error states
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");

  //flag states
  const [isLoading, setIsLoading] = useState(false);

  const onCheckPhoneNumber = (text: string) => {
    const number = text.replace(/\D/g, "");
    setPhoneNumber(number);
  };
  const onClickSendMessage = async () => {
    setIsLoading(true);
    const firstNameValidation = isInputEmpty(firstName);
    const lastNameValidation = isInputEmpty(lastName);
    const emailValidation = validateEmail(email);
    const phoneNumberValidation = validateMobileNumber(phoneNumber);

    if (!firstNameValidation?.success) {
      setFirstNameError("Please enter your first name");
    } else {
      setFirstNameError("");
    }
    if (!lastNameValidation?.success) {
      setLastNameError("Please enter your last name");
    } else {
      setLastNameError("");
    }
    if (!emailValidation?.success) {
      setEmailError(emailValidation?.msg);
    } else {
      setEmailError("");
    }
    if (!phoneNumberValidation?.success) {
      setPhoneNumberError(phoneNumberValidation?.msg);
    } else {
      setPhoneNumberError("");
    }

    if (
      !firstNameValidation.success ||
      !lastNameValidation.success ||
      !emailValidation.success ||
      !phoneNumberValidation.success
    )
      return setIsLoading(false);
    try {
      const payload = await addDoc(collection(db, "contactMessages"), {
        firstName,
        lastName,
        email,
        phoneNumber,
        desc,
        createdAt: new Date(),
      });
      console.log("Document written with ID:", payload.id);
      if (payload.id) {
        Toaster({
          type: "success",
          message: "Message sent successfully!",
        });
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhoneNumber("");
        setDesc("");
      }
    } catch (error) {
      Toaster({
        type: "error",
        message: "Something went wrong",
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="app_card contactUsForm_container">
      <ToastContainer />
      <h4>Start Your Project</h4>
      <div>
        <LabelInput
          onChangeText={setFirstName}
          value={firstName}
          placeholder="John"
          label="First Name"
          type="text"
          error={firstNameError}
        />
        <LabelInput
          onChangeText={setLastName}
          value={lastName}
          placeholder="Doe"
          label="Last Name"
          type="text"
          error={lastNameError}
        />
        <LabelInput
          onChangeText={setEmail}
          value={email}
          placeholder="absd@gmail.com"
          label="Email Address"
          type="text"
          error={emailError}
        />
        <LabelInput
          onChangeText={onCheckPhoneNumber}
          value={phoneNumber}
          placeholder="9999999999"
          label="Phone Number"
          type="tel"
          maxLength={10}
          error={phoneNumberError}
        />
        <DescriptionInput
          onChangeText={setDesc}
          value={desc}
          placeholder="Tell us about us your project....."
          label="Description "
        />
      </div>
      <Button
        title="Send Message"
        onClickButton={onClickSendMessage}
        className="sendMessage_btn"
        backgroundColor="linear-gradient(135deg, hsl(214 84% 56%),hsla(214, 77%, 57%, 1.00), hsl(263 70% 50%))"
        isLoading={isLoading}
      />
    </div>
  );
};

export default ContactUsForm;
